module.exports = __webpack_public_path__ + "media/images/thumbs/biology/m_animation_red_blood_cells_7-6b5e3a3d990932df98b5dfcbf5b62fae.jpg";